module.exports = __webpack_public_path__ + "img/icons B_30.bce0fcae.png";